//core ===
import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store.js'

//tool ===
import _ from 'lodash';
import okaTool from './okaTool.js'
import siteConfig from './siteConfig.js'
import siteTool from './siteTool.js'
import talkTool from './talkTool.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookie from 'vue-cookie'
import VeeValidate, { Validator } from 'vee-validate'
import validatorExtend from './validate-extend'
// import './registerServiceWorker'

//UI ===
import * as d3 from 'd3'
import chart from 'chart.js'
import 'chartjs-plugin-labels'
import * as topojson from 'topojson'
import './sass/global.scss'

let _development = process.env.NODE_ENV === 'development';

//set ===
Vue.config.productionTip = false;
Vue.config.devtools = _development;
Vue.prototype.$chart = chart;
Vue.prototype.$d3 = d3;
Vue.prototype.$topojson = topojson;
Vue.use(okaTool);
Vue.use(siteTool);
Vue.use(talkTool);
Vue.use(siteConfig);
Vue.use(VueAxios, axios);
Vue.use(VueCookie);

Vue.use(VeeValidate, {
    events: 'blur|change|input',
});

Vue.mixin({
    methods: {
        receiveEvent: function() {
            this.$siteTool.receiveEvent(this, arguments);
        },
        $t: function(str, opt) { //key, option
            let $state = store.state,
                _langID = $state.langID,
                $langLibrary = $state.langLibrary || {},
                $library = $langLibrary[_langID] || {}

            let _strLowerCase = str.toLowerCase();

            if( $library[_strLowerCase] ) {
                let _str = $library[_strLowerCase],
                    $match = _str.match(/\$\{(.*?)}/g);

                if ( $match && opt ) {

                    for (let _key in opt ) {
                        _str = _str.replaceAll('${' + _key + '}', opt[_key])
                    }
                }

                return _str;
            }else {
                return str;
            }
        },
    }
});

chart.defaults.global.defaultFontColor = '#1c1d2e';

chart.defaults.global.tooltips.callbacks.label = function(tooltipItem){
    return okaTool.numberToStringFormat(tooltipItem.yLabel);
}

chart.defaults.global.plugins.labels = {
    fontColor: 'transparent',
}

validatorExtend(Validator);

//loading process ===
let $exception  = [ //match 到包含的字串就不轉
        siteConfig.talkDomainUrl,
        '/comm_api_error/',
        '/Favorite/',
        '/Product/BasicClass/',
        '/Product/List/',
        '/Product/Info/',
        '/ShoppingCart/List/',
        '/ShoppingCart/Add/',
        '/ShoppingCart/Delete/',
        '/ShoppingCart/Edit/',
        '/CartMaster/Info/',
        '/Package/List/',
        '/Quality/List/',
        '/Product/Companylist/',
        '/Holiday/List/',
        '/i18n.json',
        '/document/',
        // '/Order/List/',
    ]

axios.defaults.withCredentials = false;

axios.interceptors.request.use(config => {
    let _url = config.url,
        _operator = _url + '/',
        _include = $exception.find(str => _operator.includes(str));

    if( !_include ) {
        store.commit('isLoadingChange', true);
        console.log(_url, '+')
    }

    let $state = store.state,
        _langID = $state.langID,
        $user = $state.user,
        _token = $state.token;

    if( _operator.match(siteConfig.ApiUrl) ) {
        _url = _url +'/'+ _langID;

        if( !_url.includes('/login/') && !_url.includes('/SalesmanByRegister') ) {

            if( $user.sn && !_url.includes('/users/info/') && !_url.includes('/users/refresh/') && !_url.includes('/document/') ) {
                _url = _url +'/'+ $user.sn
            }
    
            if( _token ) {
                config.headers.Authorization = _token;
            }
        }
    }

    config.url = _url;

    return config;

}, error => {
    store.commit('isLoadingChange', false);

    return Promise.reject(error);
});

axios.interceptors.response.use(async response => {
    let $config = response.config,
        _url = $config.url,
        _include = $exception.find(str => _url.includes(str));

    if( !_include ) {
        store.commit('isLoadingChange', false);
        console.log(_url, '-')
    }

    let $data = response.data;

    if( $config.responseType === 'blob' && response.headers['content-type'].includes('application/json') ) {

        let $_parseFile = (data) => { //如果是 blob json，就把資料轉出來

            return new Promise((resolve, reject) => { //reader.readAsText 不支持 Promise, 所以要包一層 Promise
                let $blb = new Blob([data], {
                        type: 'json',
                    }),
                    $reader = new FileReader();
                    
                $reader.onload = (doc) => {

                    if ( doc.target.readyState === 2 ) { 
                        resolve(JSON.parse(doc.target.result));
                    }else {
                        reject(doc);
                    }
                };
                
                $reader.onerror = (error) => {
                    reject(error);
                };

                $reader.readAsText($blb);
            });
        }

        $data = await $_parseFile($data);
    }

    if( $data && $data.ver ) {
        store.commit('updateVersion', $data.ver);
    }

    if( $data && $data.code ) { //我們的 api

        if( $data.code === '0000' || ($data.code && $data.code.match && $data.code.match(/^3/)) ) {
            //20221013 無人工審核條件比對不正確時產生3002，但不影響執行結果
            return $data.data;
        }else {
            throw $data;
        }
    }else {
        return response;
    }

}, error => {
    store.commit('isLoadingChange', false);

    return Promise.reject(error);
});

let _user = VueCookie.get('user'),
    _token = VueCookie.get('token');

if( _user && _token ) {
    store.commit('userSet', JSON.parse(_user));

    store.commit('changeState', {
        token: _token
    });

    store.commit('initTalkData');
    store.commit('initUnDiscountCuno');
}

let _accounts = VueCookie.get('accounts') || '',
    $accounts = []

if( _accounts ) {
    $accounts = JSON.parse(_accounts);
}

if( $accounts.length ) {

    store.commit('changeState', {
        accounts: $accounts,
    });
}

let _viewLang = localStorage.getItem('viewLang') || 'zh';

store.commit('setLang', {
    id: _viewLang
});

store.commit('initProductClassData');
store.commit('initHolidayList');
store.commit('initUserData');

store.commit('getLang', () => {

    new Vue({
            router,
            store,
            render: h => h(App),
        }).$mount('#app');
});